<i18n
  src="@/locales/components/views/layout/quality_reports/rejection_classification.yml"
  lang="yaml"
></i18n>

<template>
  <div class="rounded-lg border-l-4">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
      <div
        v-for="(classification, index) in classifications"
        :key="index"
        class="flex items-center gap-3 p-3 bg-white rounded-lg shadow-sm"
      >
        <div
          :class="[
            classification.colors.circle,
            'w-7 h-7 rounded-full flex-shrink-0'
          ]"
        ></div>
        <div>
          <p class="text-xs font-bold" :class="classification.colors.text">
            {{ classification.range }}
          </p>
          <p class="text-xs text-gray-600">
            {{ translatedRejectionClassification[index].label }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  REJECTION_CLASSIFICATION,
  getRejectionClassification
} from "@/components/views/mixins/agro_exporter/quality_reports/rejection_classification.js";

export default {
  name: "RejectionLegend",
  data() {
    return {
      classifications: REJECTION_CLASSIFICATION
    };
  },
  computed: {
    translatedRejectionClassification() {
      return getRejectionClassification(this.$t);
    }
  }
};
</script>
